module.exports = __webpack_public_path__ + "img/piano-aperitivo.c05ff393.jpg";